// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"1761":"d0deef33","9163":"8d4a53b3"}[chunkId] || chunkId) + "." + {"1761":"5e418f71f9ad5f8f","3307":"9c5619ca7a5f4d43","5658":"834aeeffc2f80e76","9163":"11d2704a0631bbf2"}[chunkId] + ".js";
};